import { Phone, Mail, MapPin, ArrowUpRight } from "lucide-react";
import { Reveal, Eyebrow } from "./Reveal";
import { WhatsAppIcon } from "./WhatsAppIcon";
import { CONTACT } from "../../data/site";

const Row = ({ icon: Icon, label, value, href, testid, external }) => (
  <a href={href} data-testid={testid} target={external ? "_blank" : undefined} rel={external ? "noopener noreferrer" : undefined} className="group flex items-start gap-5 border-b border-white/15 py-6 transition-colors hover:bg-white/5">
    <Icon className="mt-1 h-5 w-5 shrink-0 text-[var(--rust-light)]" />
    <span className="flex-1">
      <span className="block font-mono text-xs uppercase tracking-wider text-white/50">{label}</span>
      <span className="mt-1 block text-lg font-semibold text-white">{value}</span>
    </span>
    <ArrowUpRight className="h-5 w-5 text-white/40 transition-transform group-hover:-translate-y-1 group-hover:translate-x-1 group-hover:text-white" />
  </a>
);

export const Contact = () => (
  <section id="contact" data-testid="contact-section" className="section bg-[var(--ink)] text-white">
    <div className="mx-auto grid max-w-7xl gap-16 px-5 md:px-10 lg:grid-cols-2">
      <Reveal>
        <Eyebrow light>Get in touch</Eyebrow>
        <h2 className="section-title mt-4 text-white">Talk to Darshan</h2>
        <p className="mt-6 max-w-md text-white/70">For tenders, site visits or a copy of any work done certificate, call or message directly.</p>
        <div className="mt-8 flex flex-wrap gap-3">
          <a href={CONTACT.phoneTel} data-testid="contact-call-button" className="btn-rust inline-flex items-center gap-2 px-6 py-4"><Phone className="h-4 w-4" /> Call now</a>
          <a href={CONTACT.whatsapp} target="_blank" rel="noopener noreferrer" data-testid="contact-whatsapp-button" className="btn-ghost inline-flex items-center gap-2 px-6 py-4"><WhatsAppIcon className="h-4 w-4" /> WhatsApp</a>
        </div>
        <div className="mt-10 border-t border-white/15">
          <Row icon={Phone} label="Phone" value={CONTACT.phoneDisplay} href={CONTACT.phoneTel} testid="contact-phone-link" />
          <Row icon={Mail} label="Email" value={CONTACT.email} href={`mailto:${CONTACT.email}`} testid="contact-email-link" />
          <Row icon={MapPin} label="Office" value={CONTACT.address} href={CONTACT.mapLink} testid="contact-address-link" external />
        </div>
      </Reveal>
      <Reveal delay={0.15} className="min-h-[420px]">
        <iframe
          title="Vata Infrastructures office location"
          data-testid="contact-map"
          src={CONTACT.mapEmbed}
          className="h-full min-h-[420px] w-full border-0 grayscale-[60%] contrast-125"
          loading="lazy"
          referrerPolicy="no-referrer-when-downgrade"
        />
      </Reveal>
    </div>
  </section>
);
